<template lang="pug">
  #team-edit
    WtTile(ancestor vertical :is-loading="teamEditLoading")
      WtTile(parent)
        WtTile
          .level.team-edit-header
            .level-left
              .level-item
                WtTitle(h1) {{ editedTeam.name }}
            .level-right
              .level-item(v-if="isAdminCenter")
                WtButton(isRouterLink :to="{ name: 'TeamCenterSettings' }" color="primary") BACK TO TEAM CENTER
              .level-item(v-else)
                WtButton(
                  @click.native="$router.back()"
                  color="primary"
                ) {{ backToText }}

      WtTile(parent vertical)
        WtTile(child :is-loading="teamEditLoading || !programTeamsLoaded")
          .level
            .level-left
              .level-item
                WtTitle(h3) Edit Team Details
            .level-right
              .level-item(v-if="isAdminCenter")
                WtButton(
                  isRouterLink
                  :to="{ name: 'Team', params: { teamId } }"
                  color="primary"
                ) VIEW TEAM
              .level-item
                WtActionMenu
                  WtActionMenuItem.delete-team.has-text-danger(
                    icon="delete"
                    text="Delete team"
                    @click.native="deleteTeamWrapper(originalTeam.id)"
                  )

          .card
            .columns
              .column.is-half
                // TEAM NAME
                BField
                  //- TODO don't want UniquenessCheck with starting value to trigger validation, v-if is a workaround
                  UniquenessCheck(
                    v-if="!teamEditLoading"
                    label="Team Name"
                    entity="teamName"
                    placeholder="My Awesome Team"
                    v-model="editedTeam.name"
                    @input="$nextTick(() => shouldDisableSave())"
                  )
                // DESCRIPTION
                BField(
                  label="Description"
                )
                  BInput(
                    name="description"
                    type="textarea"
                    maxlength="1000"
                    rows="10"
                    v-model="editedTeam.description"
                    @input="$nextTick(() => shouldDisableSave())"
                  )
              .column.is-half
                // TEAM LOGO
                BField(label="Upload Team Logo")
                  WtUploadImage(
                    v-if="!teamEditLoading"
                    entity="team"
                    :current-image="originalTeam.logo"
                    @updateImage="editedTeam.logo = $event; shouldDisableSave();"
                  )

            .columns(v-if="displayOrganizationsDropdown")
              .column.is-half
                .is-size-6.label {{_.get(coreProgramMeta,"organizationsName","Organization")}}
                WtTile.is-align-items-center
                  BDropdown(
                    v-model="editedTeam.organizationId"
                    @change="$nextTick(() => shouldDisableSave())"
                  ).full-width-dropdown
                    .sort-by-trigger(slot="trigger" slot-scope="{ active }")
                      BButton(
                        :label="editedTeam.organizationId ? _.find(programOrganizations, {id :editedTeam.organizationId}).name : 'Select Organization'"
                        :icon-right="active ? 'chevron-up' : 'chevron-down'"
                      )
                    BDropdownItem(
                      :value="0"
                    ) None
                    template(
                      v-for="option in programOrganizations"
                      v-if="option.active"
                      )
                      BDropdownItem(
                        :value="option.id"
                      ) {{option.name}}
          WtTitle(h3) Team Settings
          .card
            .columns
              .column.is-half
                // INVITE ONLY / PUBLIC
                WtSwitchQuestionInput(
                  label="Who can see and join this team? "
                  true-value-text="Selected Members Only"
                  :false-value-text="orgsOn"
                  v-model="editedTeam.inviteOnly"
                  @input="$nextTick(() => shouldDisableSave())"
                  name="inviteOnly"
                )
              .column.is-half(v-if="$auth.user().isAdmin")
                // MAX MEMBERS
                BField(
                  label="Max Members"
                )
                  BInput(
                    name="maxMembers"
                    type="number"
                    v-model="editedTeam.maxMembers"
                    :min="editedTeam.numMembers"
                    @input="$nextTick(() => shouldDisableSave())"
                  )
          .team-edit-form-controls
            .level.is-mobile
              .level-left
                .level-item
                  WtButton(
                    is-text
                    color="lightgrey"
                    size="medium"
                    @click.native="setLocalData(); disableSave = true"
                  ) RESET
                .level-item
                  WtButton(
                    color="primary"
                    size="large"
                    @click.native="saveChanges"
                    :disabled="disableSave"
                    :loading="saveInProgress"
                  ) SAVE CHANGES

        WtTile(child :is-loading="teamEditLoading || !programTeamsLoaded")
          WtTitle(h3) Team Members
          .card
            TeamMembers(
              isTeamEdit
              :teamMembers="editedTeam.members"
              :key="editedTeam.members.length"
              v-if="!teamEditLoading && _.has(editedTeam, 'members')"
              :team="editedTeam"
              @memberRemoved="memberRemoved"
            )

        BCollapse.card.my-5(
          aria-id="includeMoreMembers"
          :open.sync="includeMoreMembersOpen"
        )
          .card-header(
            slot='trigger',
            role='button',
            aria-controls='includeMoreMembers'
          )
            .card-header-title
              WtTitle(card-title-large v-if="!isLeaderEdit") Add or Invite More Team Members
              WtTitle(card-title-large v-else) Invite More Team Members

            a.card-header-icon
              BIcon(:icon="includeMoreMembersOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
          .column
            span(v-if="teamIsFull").has-text-danger
              | Team is full. Remove existing team members or increase team size to invite more members.
            .card(:class="{ 'disabled': teamIsFull }")
              BField(v-if="!isLeaderEdit")
                BRadio(size="is-large" v-model="includeByType" native-value="invite") Invite Members
              BField(v-if="!isLeaderEdit")
                BRadio(size="is-large" v-model="includeByType" native-value="add") Add Members
              section.section
                TeamIncludeMembers(
                  v-if="!teamEditLoading"
                  :team="editedTeam"
                  :includeByType="includeByType"
                  :inOrganizationId="_.get(originalTeam, 'organizationId', null)"
                )
                BField
                  .level.is-mobile
                    .level-left
                      .level-item
                        WtButton(
                          color="primary"
                          size="large"
                          @click.native="includeMembers"
                          :disabled="disableIncludeMembers"
                          :loading="includeMembersInProgress"
                        ) {{ includeByType === "invite" ? "SEND INVITES" : "ADD MEMBERS NOW" }}

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtUploadImage from "@@/WtUploadImage/WtUploadImage";
import WtReadonlyInputControls from "@@/WtReadonlyInputControls/WtReadonlyInputControls";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import WtRadioQuestionInput from "@@/WtRadioQuestionInput/WtRadioQuestionInput";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";
import TeamMembers from "@@/Teams/TeamMembers";
import TeamIncludeMembers from "@@/Teams/TeamIncludeMembers";

export default {
  name: "TeamEdit",

  components: {
    TeamIncludeMembers,
    WtActionMenu,
    WtActionMenuItem,
    WtTile,
    WtTitle,
    WtButton,
    WtUploadImage,
    WtSwitchQuestionInput,
    WtRadioQuestionInput,
    WtReadonlyInputControls,
    UniquenessCheck,
    TeamMembers
  },

  mixins: [analyticsTrackingMixin, dateUtilityMixin, numberUtilityMixin],

  props: {
    teamId: {
      type: [Number, String],
      required: true
    }
  },

  data() {
    return {
      teamEditLoading: true,
      originalTeam: {},
      editedTeam: {
        id: null,
        name: null,
        description: null,
        public: null,
        inviteOnly: null,
        logo: null,
        maxMembers: null,
        numMembers: null,
        members: null
      },
      includeMoreMembersOpen: false,
      includeMembersInProgress: false,
      includeByType: "invite",
      saveInProgress: false,
      disableSave: true,
      fromRoute: ""
    };
  },

  computed: {
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("program", [
      "coreProgramMeta",
      "programTeams",
      "programTeamsLoaded",
      "programOrganizations",
      "programOrganizationsLoaded",
      "isProTier"
    ]),
    ...mapGetters("challengeBuilder", ["stagedMembers"]),

    orgsOn() {
      if (this.coreProgramMeta.organizationsOn) {
        return "Organization Members";
      }
      return "All Members";
    },

    isAdminCenter() {
      return /admin/.test(this.$route.path);
    },

    isLeaderEdit() {
      if (this.$auth.user().isAdmin) return false;
      const member = this._.find(this.originalTeam.members, {
        id: this.$auth.user().id
      });
      if (!member) return false;
      return member.isTeamLeader;
    },

    backToText() {
      return this.fromRoute === "Team" ? "BACK TO TEAM" : "BACK TO ALL TEAMS";
    },

    disableIncludeMembers() {
      return this.stagedMembers.length < 1 || this.includeMembersInProgress;
    },

    teamIsFull() {
      return this.editedTeam.numMembers >= this.editedTeam.maxMembers;
    },

    displayOrganizationsDropdown() {
      return (
        this.isAdmin &&
        this.isProTier &&
        this._.get(this.coreProgramMeta, "organizationsOn", false)
      );
    }
  },

  async mounted() {
    this.trackFeatureView("teams", "team_edit");
    if (this.isProTier && this.isAdmin && !this.programOrganizationsLoaded) {
      await this.fetchProgramOrganizations({
        programId: this.coreProgramMeta.id
      });
    }
    await this.setLocalData();
    this.teamEditLoading = false;
  },

  methods: {
    ...mapActions("teams", [
      "teamShow",
      "updateTeam",
      "sentTeamInvites",
      "addMembersToTeam",
      "deleteTeam"
    ]),
    ...mapActions("invites", ["inviteTeamMembers"]),
    ...mapActions("challengeBuilder", ["emptyStagedMembers"]),
    ...mapActions("program", [
      "searchMembers",
      "setMembersResponseObject",
      "fetchProgramOrganizations"
    ]),
    ...mapActions("pages", ["setPageLoaded", "setPageLoading"]),
    ...mapActions(["snackBar"]),

    async setLocalData() {
      if (this._.isEmpty(this.originalTeam)) {
        this.originalTeam = await this.teamShow({
          teamId: this.teamId,
          withMembers: 1
        });
      }

      this.editedTeam = {
        id: this.originalTeam.id,
        name: this.originalTeam.name,
        teamNameURL: this.originalTeam.teamNameURL,
        description: this.originalTeam.description,
        public: this.originalTeam.public,
        inviteOnly: this.originalTeam.inviteOnly,
        logo: this.originalTeam.logo,
        maxMembers: this.originalTeam.maxMembers,
        numMembers: this.originalTeam.numMembers,
        members: this.originalTeam.members,
        organizationId: this.originalTeam.organizationId
      };
    },

    isOriginalValue(attribute, newValue) {
      let oldValue = this.originalTeam[attribute];

      return oldValue === newValue;
    },

    shouldDisableSave() {
      const keysToCheck = [
        "description", // string
        "inviteOnly", // boolean
        "logo", // string and null
        "maxMembers", // integer | or string after editing
        "name", // string
        "public", // boolean
        "teamNameURL", // string
        "organizationId" // int or string
      ];
      let isDifferent = false;

      keysToCheck.forEach(key => {
        const original = this.originalTeam[key];
        let edited = this.editedTeam[key];

        if (key === "maxMembers") {
          // The number input saves value as string
          edited = parseInt(edited);
        } else if (key === "logo") {
          if (edited === null) {
            // After clicking "EDIT" the value becomes null
            edited = original;
          }
        }

        if (original !== edited) {
          isDifferent = true;
        }
      });
      this.disableSave = !isDifferent;
    },

    deleteTeamWrapper(teamId) {
      this.$buefy.dialog.confirm({
        title: "Delete This Team",
        confirmText: "Delete This Team",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to delete this team?  *Note, this cannot be undone.",
        onConfirm: async () => {
          this.setPageLoaded({ key: "MyDashboard", value: false });
          this.setPageLoaded({ key: "Teams", value: false });
          await this.deleteTeam(teamId);
          this.$router.push({ name: "Teams" });
        }
      });
    },

    async includeMembers() {
      this.includeMembersInProgress = true;
      const memberIds = this.stagedMembers.map(member => member.id);

      if (this.includeByType === "add") {
        const team = await this.addMembersToTeam({
          team: this.originalTeam,
          memberIds
        });

        this.originalTeam = team;
        this.editedTeam.numMembers = team.numMembers;
        this.editedTeam.members = team.members;
      }

      if (this.includeByType === "invite") {
        await this.inviteTeamMembers({
          teamId: this.originalTeam.id,
          recipientIds: memberIds
        });
      }

      this.emptyStagedMembers();
      this.includeMembersInProgress = false;
    },

    async saveChanges() {
      const formData = new FormData();
      let numberOfChangedAttributes = 0;

      const attributes = [
        "name",
        "description",
        "inviteOnly",
        "maxMembers",
        "numMembers",
        "logo", // TODO: align API key to logo or image
        "organizationId"
      ];

      attributes.forEach(attribute => {
        let newValue = this.editedTeam[attribute];

        if (attribute === "name") {
          formData.append("name", newValue || this.originalTeam.name);
          if (!this.isOriginalValue(attribute, newValue)) {
            numberOfChangedAttributes++;
          }
        } else if (!this.isOriginalValue(attribute, newValue)) {
          attribute = attribute === "logo" ? "image" : attribute; // TODO: align API key to logo or image
          formData.append(attribute, newValue);

          numberOfChangedAttributes++;
        }
      });

      const payload = {
        teamId: this.originalTeam.id,
        formData
      };

      this.saveInProgress = true;

      if (numberOfChangedAttributes > 0) {
        const response = await this.updateTeam(payload);
        const updatedTeam = response.data.data;

        this.saveInProgress = false;

        this.isAdminCenter
          ? this.$router.push({ name: "TeamCenterSettings" })
          : this.$router.push({
              name: "Team",
              params: { teamId: updatedTeam.teamNameURL }
            });
      } else {
        this.saveInProgress = false;

        this.isAdminCenter
          ? this.$router.push({ name: "TeamCenterSettings" })
          : this.$router.push({
              name: "Team",
              params: { teamId: this.originalTeam.teamNameURL }
            });
      }
    },

    memberRemoved(removedMemberId) {
      this.editedTeam.numMembers = this.editedTeam.numMembers - 1;
      // refresh member list
      this.editedTeam.members = this.editedTeam.members.filter(
        member => member.id !== removedMemberId
      );
    }
  },

  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.fromRoute = from.name;
    });
  }
};
</script>

<style lang="sass" scoped>
#team-edit
  .team-edit-header
    width: 100%
  .card
    padding: 1.5rem
    margin-top: 1.5rem
    margin-bottom: 1.5rem
    overflow: visible
  .team-edit-form-controls
    margin-top: 3.5rem
  .disabled
    opacity: 0.4
    pointer-events: none
  .full-width-dropdown
    width: 100%
    /deep/ div,button
      width: 100%
    /deep/ button
      display: flex
      justify-content: space-between
</style>
